// Birds of Condor GWP (Gift With Purchase) JavaScript
// Global functions for GWP functionality

class BirdsGWP {
  constructor() {
    this.cartUpdateUnsubscriber = null;
    this.init();
  }

  init() {
    // Subscribe to cart updates
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        this.handleCartUpdate(event);
      });
    }

    // Check GWP on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.checkGWPInCart();
        this.initVariantSelectionHandlers();
      });
    } else {
      this.checkGWPInCart();
      this.initVariantSelectionHandlers();
    }
  }

  handleCartUpdate(event) {
    // Give a small delay to ensure DOM is updated
    setTimeout(() => {
      this.checkGWPInCart();
      this.initVariantSelectionHandlers();
    }, 100);
  }

  // Helper function to check if a price represents zero value regardless of currency
  isZeroPrice(priceString) {
    if (!priceString || priceString === '') return true;
    
    // Remove currency codes in parentheses first (e.g., "(AUD)", "(USD)", "(EUR)")
    const withoutCurrencyCode = priceString.replace(/\s*\([A-Z]{3}\)\s*/g, '');
    
    // Extract numeric value from price string (handles different currency formats)
    // Keep only digits, dots, and commas, remove everything else (currency symbols, spaces)
    const numericValue = withoutCurrencyCode.replace(/[^\d.,]/g, '').replace(',', '.');
    const price = parseFloat(numericValue);
    
    return isNaN(price) || price === 0;
  }

  checkGWPInCart() {
    const button = document.querySelector('.gwp-button');
    const variantpicker = document.querySelector('.gwp-variant-picker-container');
    
    if (!button) return;

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Get all GWP variant IDs from the JSON script
        const container = document.getElementById('birds-gwp-picker-container');
        let gwpVariantIds = [];
        
        if (container) {
          const variantIdsJson = container.querySelector('script[data-variant-ids]');
          if (variantIdsJson) {
            gwpVariantIds = JSON.parse(variantIdsJson.textContent);
          } else {
            // fallback to single variant
            const productId = button.getAttribute('data-product-id');
            if (productId) {
              gwpVariantIds = [parseInt(productId)];
            }
          }
        }
        
        // Check if any GWP variant is in the cart
        const gwpInCart = cart.items.some(item => gwpVariantIds.includes(item.variant_id));
        
        if (gwpInCart) {
          button.disabled = true;
          const gwpProductName = button.getAttribute('data-gwp-name') || 'Gift';
          const addedText = button.getAttribute('data-gwp-added-text') || '{product_name} Added';
          button.textContent = addedText.replace('{product_name}', gwpProductName);
          if (variantpicker) {
            variantpicker.classList.add('js-hidden');
          }
        } else {
          button.disabled = false;
          const gwpProductName = button.getAttribute('data-gwp-name') || 'Gift';
          const gwpProductPrice = button.getAttribute('data-gwp-price') || '';
          const buttonText = button.getAttribute('data-gwp-button-text') || 'Add {product_name} to Cart · {price}';
          
          // Only show price if it exists and is not zero
          let priceWithStrikethrough;
          if (!this.isZeroPrice(gwpProductPrice)) {
            priceWithStrikethrough = `<span style="text-decoration: line-through;opacity:0.5;">${gwpProductPrice}</span>`;
          } else {
            priceWithStrikethrough = '';
          }
          
          button.innerHTML = buttonText.replace('{product_name}', gwpProductName).replace('{price}', priceWithStrikethrough);
          if (variantpicker) {
            variantpicker.classList.remove('js-hidden');
          }
        }
      })
      .catch(error => {
        console.error('Error checking cart:', error);
        button.disabled = false;
        const gwpProductName = button.getAttribute('data-gwp-name') || 'Gift';
        const buttonText = button.getAttribute('data-gwp-button-text') || 'Add {product_name} to Cart · {price}';
        const gwpProductPrice = button.getAttribute('data-gwp-price') || '';
        
        // Only show price if it exists and is not zero
        let priceWithStrikethrough;
        if (!this.isZeroPrice(gwpProductPrice)) {
          priceWithStrikethrough = `<span style="text-decoration: line-through;opacity:0.5;">${gwpProductPrice}</span>`;
        } else {
          priceWithStrikethrough = '';
        }
        
        button.innerHTML = buttonText.replace('{product_name}', gwpProductName).replace('{price}', priceWithStrikethrough);
      });
  }

  initVariantSelectionHandlers() {
    const container = document.getElementById('birds-gwp-picker-container');
    if (!container) return;

    const button = container.querySelector('.gwp-button');
    if (!button) return;

    // Remove existing listeners to prevent duplicates
    const existingHandler = container._gwpVariantHandler;
    if (existingHandler) {
      container.removeEventListener('change', existingHandler);
    }

    // Create new handler
    const handler = (e) => {
      if (e.target && e.target.name && e.target.type === 'radio') {
        // Collect all selected values for each option
        const selectedOptions = [];
        const fieldsets = container.querySelectorAll('fieldset');
        fieldsets.forEach(function(fieldset) {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (checked) {
            selectedOptions.push(checked.value);
          }
        });

        // Get variants and IDs from JSON
        const variantsJson = container.querySelector('script[data-variants]');
        const variantIdsJson = container.querySelector('script[data-variant-ids]');
        if (!variantsJson || !variantIdsJson) return;
        
        const variants = JSON.parse(variantsJson.textContent);
        const variantIds = JSON.parse(variantIdsJson.textContent);

        // Find the variant that matches the selected options
        let foundVariantId = null;
        for (let i = 0; i < variants.length; i++) {
          let match = true;
          for (let j = 0; j < selectedOptions.length; j++) {
            if (variants[i][j] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            foundVariantId = variantIds[i];
            break;
          }
        }

        if (foundVariantId && button) {
          button.setAttribute('data-product-id', foundVariantId);
        }
      }
    };

    // Store handler reference and add listener
    container._gwpVariantHandler = handler;
    container.addEventListener('change', handler);
  }

  addGWPToCart() {
    const button = document.querySelector('.gwp-button');
    if (!button) return;

    button.disabled = true;
    button.textContent = 'Adding...';

    const data = {
      items: [{
        id: button.getAttribute('data-product-id'),
        quantity: 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      console.log('Product added to cart:', response);
      
      // Trigger cart update event
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'gwp-add-to-cart',
          cartData: response
        });
      }
      
      // Update cart drawer if it exists
      return fetch(`${routes.cart_url}?section_id=cart-drawer`);
    })
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      // Check GWP status after cart drawer update
      this.checkGWPInCart();
    })
    .catch(error => {
      console.error('Error:', error);
      this.checkGWPInCart(); // Reset button state on error
    });
  }

  destroy() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
}

// Global function for backward compatibility
function addGWPToCart() {
  if (window.birdsGWP) {
    window.birdsGWP.addGWPToCart();
  }
}

function checkGWPInCart() {
  if (window.birdsGWP) {
    window.birdsGWP.checkGWPInCart();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.birdsGWP = new BirdsGWP();
  });
} else {
  window.birdsGWP = new BirdsGWP();
}